<template>
  <div>
    <span class="d-flex items-center">
      <p class="text-base text-medium">
        Caso você deseje <strong>usar um HTML pronto ou escrever seu próprio código</strong>, basta ativar essa opção
      </p>
      <vs-switch class="ml-2 mr-2" v-model="pasteHTML"/>
      <span class="text-base text-medium">e preencher o campo abaixo.</span>
    </span>
    
    <span>
      <p class="text-base text-medium mt-1 mb-2">
        Caso contrário,
        você pode montar seu próprio conteúdo e <strong> edita-lo da forma como achar melhor </strong> (se esse for o caso, <strong>NÃO</strong> ative o botão acima):
      </p>
    </span>

    <VueAceEditor
      mode="html"
      ref='vueAceEditor'
      v-if="pasteHTML"
      v-model="htmlCode"
      class="html-code-editor mb-6"
    />

    <VueEditor
      v-else
      ref='vue2Editor'
      v-model='htmlContent'
      use-custom-image-handler
      @image-added='handleImage'
      :editorOptions='editorOptions'
    />

    <span v-if="pasteHTML">
      <p class="text-base text-medium mb-1">
        Conteúdo Renderizado:
      </p>
      <div class="html-rendered-field">
        <div
          class="mb-12 mt-6 p-2"
          v-html="htmlCode"
        />
      </div>
    </span>
  </div>
</template>

<script>
  import { VueEditor } from 'vue2-editor/dist/vue2-editor.core.js';
  import VueAceEditor from 'vue2-ace-editor';
  import axios from 'axios';
  import { getBaseUrl, getCurrentTenant } from "@/utils";

  export default {
    data() {
      return {
        htmlCode: '',
        htmlContent: '',
        routeUrl: '',
        formattedHTML: '',
        pasteHTML: false,
        editorOptions: {
          modules: {
            toolbar: {
              container: [
                [
                  {
                    header: [
                      false, 1, 2, 3, 4, 5, 6
                    ]
                  }
                ],
                [
                  'bold', 'italic', 'underline'
                ],
                [
                  { align: '' },
                  { align: 'center' },
                  { align: 'right' },
                  { align: 'justify' }
                ],
                [ 'blockquote', 'code-block' ],
                [ { list: 'ordered' }, { list: 'bullet' }, { list: 'check' } ],
                [ { indent: '-1' }, { indent: '+1' } ],
                [ { color: [] }, { background: [] } ],
                [ 'link', 'image', 'video' ],
                [ 'clean' ]
              ]
            }
          }
        }
      };
    },
    props: {
      setData: {
        type: Boolean,
        required: true
      },
      tag: {
        type: String,
        required: true,
        default: ''
      }
    },
    watch: {
      setData(value) {
        if (value) this.setValues();
      },
      tag(value) {
        if (value !== '') this.insertTag(value);
      },
      pasteHTML(value) {
        [this.htmlContent, this.htmlCode] = value ? ['', this.htmlContent] : [this.htmlCode, ''];
      }
    },
    methods: {
      isValidHTML(content) {
        return /<(br|basefont|hr|input|source|frame|param|area|meta|!--|col|link|option|base|img|wbr|!DOCTYPE).*?>|<(a|abbr|acronym|address|applet|article|aside|audio|b|bdi|bdo|big|blockquote|body|button|canvas|caption|center|cite|code|colgroup|command|datalist|dd|del|details|dfn|dialog|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frameset|head|header|hgroup|h1|h2|h3|h4|h5|h6|html|i|iframe|ins|kbd|keygen|label|legend|li|map|mark|menu|meter|nav|noframes|noscript|object|ol|optgroup|output|p|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|tt|u|ul|var|video).*?<\/\2>/i.test(content);
      },
      setValues() {
        if (!this.pasteHTML && !this.htmlContent.trim().length) return this.$emit('htmlContent', null);
        if (this.pasteHTML && !this.htmlCode.trim().length) return this.$emit('htmlContent', null);

        var mounted;
        let footer = `<footer style="background-color: #f8f9fa; padding: 10px; border-top: 1px solid #dee2e6;"> Agradecemos por sua participação em nossa campanha! Valorizamos a sua presença. Entendemos que as preferências podem mudar e queremos garantir que sua experiência conosco seja sempre positiva. Se você deseja parar de receber nossas atualizações, clique em 'Cancelar Inscrição'. Após clicar, será direcionado a página de cancelamento. Certifique-se de confirmar o cancelamento para garantir que não irá mais receber campanhas desse e-mail.<a href="${this.routeUrl}">Cancelar Inscrição</a>.</footer>`;
        if (!this.pasteHTML) {
          let parsed = this.htmlContent + footer;

          parsed = this.changeStyle(parsed, 'ql-align-center', 'text-align: center;');
          parsed = this.changeStyle(parsed, 'ql-align-right', 'text-align: right;');

          mounted = `
            <!DOCTYPE html>\n
            <html>\n
              <body>\n
                ${parsed}
              </body>\n
            </html>\n
          `;
        } else 
        mounted = this.htmlCode + footer;
        this.$emit('htmlContent', mounted);
        return mounted;
      },
      insertTag(value) {
        if (!this.pasteHTML) {
          const editor = this.$refs.vue2Editor;

          if ( editor.quill.getSelection() ) {
            const cursorPosition = editor.quill.getSelection().index;
            this.htmlContent = this.handleContent(cursorPosition, `{{${value}}}`);
          }
        } else {
          const aceEditor = this.$refs.vueAceEditor.editor;

          if (aceEditor) {
            const position = aceEditor.getCursorPosition();
            const { row, column } = position;

            aceEditor.session.insert(
              {
                row,
                column
              },
              `{{${value}}}`
            );
          }
        }

        this.$emit('removeTag');
      },
      handleContent(position, value) {
        const quill = this.$refs.vue2Editor.quill;
        quill.clipboard.dangerouslyPasteHTML(position, value);

        return quill.root.innerHTML;
      },
      handleImage(file, quill, cursorPosition, resetEditor) {
        /**
         * The maximum image size should not exceed 10mb (2 * 1024 * 1024)
         * A lower value was left to avoid errors.
         */
        if (file.size >= 2 * 1000 * 1000) {
          return this.$vs.notify(
            {
              color: 'danger',
              title: 'A Imagem Deve ter no Máximo 2 MB de Tamanho!'
            }
          );
        }

        this.$vs.loading(
          {
            type: 'radius',
            container: '#app',
            clickEffect: true
          }
        );

        let formData = new FormData();
        formData.append('file', file);

        try {
          axios.post(
            this.uploadBaseUrl,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'Bearer ' + this.bearerToken
              }
            }
          ).then( response => this.renderImage(response.data.fileUrl, quill, cursorPosition, resetEditor) );
        } catch(error) {
          this.$vs.notify(
            {
              color: 'danger',
              title: 'Houve algum erro ao carregar a imagem!'
            }
          );
          console.error(error);
          this.$vs.loading.close('#app > .con-vs-loading');
        }
      },
      renderImage(url, quill, cursorPosition, resetEditor) {
        this.$vs.loading.close('#app > .con-vs-loading');
        quill.insertEmbed(cursorPosition, 'image', url);
        resetEditor();
      },
      changeStyle(html, className, newStyle) {
        const div = document.createElement('div');

        div.innerHTML  = html;
        const elements = div.querySelectorAll(`.${className}`);

        if (elements.length) {
          elements.forEach(
            element => {
              const existingStyle = element.getAttribute('style');
              const newStyles     = newStyle;
              const updatedStyle  = existingStyle ? existingStyle + ' ' + newStyles : newStyles;

              element.setAttribute('style', updatedStyle);
            }
          );
        }

        return div.innerHTML;
      },
    },
    computed: {
      bearerToken() {
        return this.$store.state.auth.bearer;
      },
      uploadBaseUrl() {
        return localStorage.getItem('baseUrl') + '/api/file/upload';
      },
    },
    created(){
      this.routeUrl = `${getBaseUrl()}${getCurrentTenant()}/unsubscribe/email/`
    },
    emits: [
      'htmlContent',
      'removeTag'
    ],
    components: {
      VueEditor,
      VueAceEditor
    }
  }
</script>

<style lang='scss'>
  @import '~vue2-editor/dist/vue2-editor.css';
  @import '~quill/dist/quill.core.css';
  @import '~quill/dist/quill.bubble.css';
  @import '~quill/dist/quill.snow.css';

  .html-code-editor {
    height: 250px !important;
    font-size: 18px !important;
    border: 1px solid #ccc !important;
    background-color: #f8f8f8 !important;
  }

  .html-rendered-field {
    border: 1px solid #ccc !important;
  }
</style>
